import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber',
})
export class ToNumberPipe implements PipeTransform {
  transform(value: string, decimalPlaces: number = 0): number {
    let result;

    result = parseFloat(value);
    // console.log(result);
    if (isNaN(result)) return 0;
    else
      return (
        Math.round(result * Math.pow(10, decimalPlaces)) /
        Math.pow(10, decimalPlaces)
      );
  }
}
